import { Bandage, HeartPulse, TestTube, Activity, Stethoscope } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

export const serviceIcons = { Bandage, HeartPulse, TestTube, Activity, Stethoscope };

export const ServiceCard = ({ service, featured }) => {
  const { lang, t } = useLang();
  const Icon = serviceIcons[service.icon] || Stethoscope;
  return (
    <div data-testid={`service-card-${service.id}`}
      className={`group bg-white rounded-2xl border border-slate-200 p-8 flex flex-col hover:-translate-y-1 hover:shadow-md transition-[transform,box-shadow] ${featured ? "md:col-span-2 md:flex-row md:items-center md:gap-8" : ""}`}>
      <div className={featured ? "md:flex-1" : ""}>
        <span className="inline-flex w-12 h-12 rounded-xl bg-primary/10 items-center justify-center mb-5">
          <Icon className="w-6 h-6 text-primary" />
        </span>
        <h3 className="font-heading text-xl font-semibold text-slate-900 mb-2">{lang === "ms" ? service.name_ms : service.name_en}</h3>
        <p className="text-sm text-slate-500 leading-relaxed mb-5">{lang === "ms" ? service.desc_ms : service.desc_en}</p>
      </div>
      <div className={`flex items-center justify-between ${featured ? "md:flex-col md:items-end md:gap-4" : ""}`}>
        <div>
          <span className="text-xs text-slate-400 block">{service.duration}</span>
          <span className="font-heading text-2xl font-semibold text-primary">{t("services.from")} {service.price_from}</span>
        </div>
        <Link to={`/booking?service=${service.id}`} data-testid={`service-book-${service.id}`}
          className="text-sm font-semibold text-emerald-600 hover:text-emerald-700 transition-colors">
          {t("services.book")} →
        </Link>
      </div>
    </div>
  );
};
